import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue";
import _imports_0 from '../../../images/Ico/user_profile-black.svg';
var _hoisted_1 = {
  key: 0,
  "class": "tw-flex tw-justify-center tw-bg-w-cultured tw-rounded"
};
var _hoisted_2 = {
  "class": "tw-p-20px"
};
var _hoisted_3 = ["href"];
var _hoisted_4 = {
  key: 0,
  "class": "agencyName tw-mb-0 sm:tw-inline-block"
};
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = ["innerHTML"];
var _hoisted_7 = {
  key: 1,
  "class": "agencyName tw-mb-0 sm:tw-inline-block"
};
var _hoisted_8 = ["innerHTML"];
var _hoisted_9 = ["data-id", "innerHTML"];
var _hoisted_10 = {
  "class": "tw-uppercase"
};
var _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */);
var _hoisted_12 = ["innerHTML"];
var _hoisted_13 = ["innerHTML"];
var _hoisted_14 = ["innerHTML"];
var _hoisted_15 = {
  key: 2,
  "class": "tw-col-span-2 tw-text-12 tw-ml-5px"
};
var _hoisted_16 = ["innerHTML"];
var _hoisted_17 = ["innerHTML"];
var _hoisted_18 = ["innerHTML"];
var _hoisted_19 = {
  key: 3,
  "class": "tw-col-span-2 tw-mt-10px"
};
var _hoisted_20 = ["innerHTML"];
var _hoisted_21 = {
  "class": "tw-flex tw-items-center tw-p-25px tw-w-full tw-m-0"
};
var _hoisted_22 = ["src", "alt"];
var _hoisted_23 = {
  "class": "tw-p-20px tw-relative",
  style: {
    "width": "70%"
  }
};
var _hoisted_24 = ["src"];
var _hoisted_25 = {
  "class": "agencyName tw-mb-0 sm:tw-block"
};
var _hoisted_26 = ["href"];
var _hoisted_27 = ["innerHTML"];
var _hoisted_28 = ["innerHTML"];
var _hoisted_29 = {
  key: 1,
  "class": "tw-flex tw-items-center"
};
var _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  "class": "tw-mr-2",
  height: "16",
  alt: "private user icon"
}, null, -1 /* HOISTED */);
var _hoisted_31 = ["innerHTML"];
var _hoisted_32 = ["data-id", "innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _a, _b;
  var _component_phone_icon = _resolveComponent("phone-icon");
  var _component_base_button = _resolveComponent("base-button");
  var _component_card_slider = _resolveComponent("card-slider");
  var _component_base_alert = _resolveComponent("base-alert");
  var _component_base_input = _resolveComponent("base-input");
  var _component_BaseTextarea = _resolveComponent("BaseTextarea");
  var _component_base_checkbox = _resolveComponent("base-checkbox");
  var _component_custodian_supervisor_card = _resolveComponent("custodian-supervisor-card");
  var _component_BaseBtModal = _resolveComponent("BaseBtModal");
  var _component_limit_modal = _resolveComponent("limit-modal");
  var _component_limit_saved_modal = _resolveComponent("limit-saved-modal");
  var _component_unauthorized_modal = _resolveComponent("unauthorized-modal");
  var _component_contact_agency_success = _resolveComponent("contact-agency-success");
  var _component_generic_success_modal = _resolveComponent("generic-success-modal");
  return _openBlock(), _createElementBlock("div", null, [_ctx.success === null && _ctx.errorCode === -1 || _ctx.type === 'agency' && !_ctx.reopenAfterLogin ? (_openBlock(), _createBlock(_component_BaseBtModal, {
    key: 0,
    "show-modal": _ctx.show,
    "header-title": !_ctx.isAuction ? _ctx.labels.areYouInterested : _ctx.endedAuction ? _ctx.labels.requestInfos : _ctx.labels.requestConsulting,
    "custom-modal-header-classes": "tw-py-20px tw-bg-white sm:tw-bg-w-cultured",
    "custom-modal-body-classes": "tw-flex tw-flex-col tw-bg-white sm:tw-bg-w-cultured",
    "custom-modal-dialog-classes": "modal-md",
    "custom-modal-content-classes": "tw-bg-white sm:tw-bg-w-cultured",
    "with-custom-footer": ((_a = _ctx.modelValue) === null || _a === void 0 ? void 0 : _a.subscriptionType) != _ctx.SUBSCRIPTION_TYPE.FREE && _ctx.isDesktopMode,
    "custom-modal-footer-classes": "tw-p-0 sm:tw-rounded-t",
    onClosed: _ctx.closedModal
  }, _createSlots({
    body: _withCtx(function () {
      var _a, _b, _c, _d, _e;
      return [_createCommentVNode(" AGENCY "), ((_a = _ctx.modelValue) === null || _a === void 0 ? void 0 : _a.subscriptionType) != _ctx.SUBSCRIPTION_TYPE.FREE && !_ctx.isDesktopMode && !_ctx.isAuction ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("a", {
        "class": "agency-url tw-text-w-black tw-no-underline",
        href: _ctx.agencyData ? _ctx.agencyData.url : '#',
        onClick: _cache[0] || (_cache[0] = _withModifiers(function ($event) {
          var _a;
          return _ctx.redirectToAgencyDetails(_ctx.agencyData.url || '', (_a = _ctx.modelValue) === null || _a === void 0 ? void 0 : _a.premium);
        }, ["prevent"]))
      }, [!_ctx.advertisingPublicUserID ? (_openBlock(), _createElementBlock("p", _hoisted_4, [_createElementVNode("span", {
        "class": "tw-block tw-font-semibold tw-text-12 sm:tw-text",
        innerHTML: _ctx.agencyData ? _ctx.agencyData.name : ''
      }, null, 8 /* PROPS */, _hoisted_5), _createElementVNode("span", {
        "class": "tw-block agencyAddress tw-text-12",
        innerHTML: _ctx.agencyData ? _ctx.agencyData.address : ''
      }, null, 8 /* PROPS */, _hoisted_6)])) : (_openBlock(), _createElementBlock("p", _hoisted_7, [_createElementVNode("span", {
        "class": "tw-block tw-font-semibold tw-text-12 sm:tw-text",
        innerHTML: _ctx.publicUserName ? "".concat(_ctx.publicUserName, " - Utente privato") : ''
      }, null, 8 /* PROPS */, _hoisted_8)]))], 8 /* PROPS */, _hoisted_3), _ctx.isPremium ? (_openBlock(), _createBlock(_component_base_button, {
        key: 0,
        "data-cy": "show-phone-btn-desktop",
        "btn-class": "tw-hidden sm:tw-block tw-mt-10px tw-btn-sm tw-btn-outline tw-btn-w-primary",
        onClick: _cache[1] || (_cache[1] = _withModifiers(function ($event) {
          return _ctx.showPhone(_ctx.agencyModalData, "".concat(_ctx.pageName, " - ").concat(_ctx.location), _ctx.displayPhone, undefined);
        }, ["prevent", "stop"]))
      }, {
        "default": _withCtx(function (_ref) {
          var hover = _ref.hover;
          return [_createVNode(_component_phone_icon, {
            "stroke-color": hover ? '#fff' : '#2b5dff',
            width: 16,
            height: 16,
            "class": "tw-inline-block"
          }, null, 8 /* PROPS */, ["stroke-color"]), _createElementVNode("span", {
            ref: "phone-".concat(_ctx.agencyModalData.agencyId),
            "class": "tw-ml-10px",
            "data-id": "phone-".concat(_ctx.agencyModalData.agencyId),
            innerHTML: _ctx.labels.phone
          }, null, 8 /* PROPS */, _hoisted_9)];
        }),
        _: 1 /* STABLE */
      })) : _createCommentVNode("v-if", true)])])) : _ctx.isAuction && _ctx.isMobile && !_ctx.endedAuction ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createCommentVNode(" CONSULTANT SLIDING BAR ELEMENT "), _createVNode(_component_card_slider, {
        "is-user-logged": _ctx.isUserLogged,
        consultants: _ctx.consultantsList
      }, null, 8 /* PROPS */, ["is-user-logged", "consultants"])], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)) : _createCommentVNode("v-if", true), _ctx.success && _ctx.type === 'agency' ? (_openBlock(), _createBlock(_component_base_alert, {
        key: 2,
        "alrt-class": "tw-alert-w-primary tw-text-center tw-mt-10px tw-border tw-border-w-primary tw-rounded",
        text: _ctx.labels.success
      }, null, 8 /* PROPS */, ["text"])) : _ctx.errorMessage ? (_openBlock(), _createBlock(_component_base_alert, {
        key: 3,
        "alrt-class": "tw-alert-w-danger tw-text-center tw-mt-10px sm:tw-mt-0 tw-border tw-border-w-danger tw-rounded"
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.labels.warningLabel), 1 /* TEXT */), _createTextVNode(": "), _hoisted_11, _createElementVNode("span", {
            innerHTML: _ctx.errorMessage
          }, null, 8 /* PROPS */, _hoisted_12)];
        }),
        _: 1 /* STABLE */
      })) : _createCommentVNode("v-if", true), _createElementVNode("form", {
        id: "send_request_modal",
        "class": "tw-grid tw-grid-cols-2 tw-w-full lg:tw-justify-between tw-gap-x-15px tw-gap-y-5px",
        onSubmit: _cache[11] || (_cache[11] = _withModifiers(function () {}, ["prevent"])),
        onKeyup: _cache[12] || (_cache[12] = function ($event) {
          return _ctx.userInteraction = true;
        })
      }, [!_ctx.isUserLogged ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_base_input, {
        modelValue: _ctx.requestData.name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return _ctx.requestData.name = $event;
        }),
        "class": "tw-col-span-2 sm:tw-col-span-1",
        "label-text": _ctx.labels.name,
        "is-valid": _ctx.isValid(_ctx.v$.requestData.name),
        required: true
      }, null, 8 /* PROPS */, ["modelValue", "label-text", "is-valid"]), _createVNode(_component_base_input, {
        modelValue: _ctx.requestData.email,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return _ctx.requestData.email = $event;
        }),
        "class": "tw-col-span-2 sm:tw-col-span-1",
        "label-text": _ctx.labels.email,
        "is-valid": _ctx.isValid(_ctx.v$.requestData.email),
        required: true
      }, null, 8 /* PROPS */, ["modelValue", "label-text", "is-valid"]), _createVNode(_component_base_input, {
        modelValue: _ctx.requestData.phone,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return _ctx.requestData.phone = $event;
        }),
        "class": "tw-col-span-2",
        "label-text": _ctx.labels.phone
      }, null, 8 /* PROPS */, ["modelValue", "label-text"])], 64 /* STABLE_FRAGMENT */)) : _createCommentVNode("v-if", true), _createVNode(_component_BaseTextarea, {
        id: "send_request_modal_notes",
        modelValue: _ctx.requestData.message,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
          return _ctx.requestData.message = $event;
        }),
        "wrapper-classes": "tw-col-span-2",
        "custom-label-classes": "tw-mb-0 sm:tw-mb-5px lg:tw-mb-10px tw-text-12 sm:tw-text tw-font-medium",
        rows: "3",
        maxlength: "400",
        placeholder: _ctx.labels.message,
        "label-text": _ctx.labels.message,
        "is-valid": _ctx.isValid(_ctx.v$.requestData.message),
        required: true
      }, null, 8 /* PROPS */, ["modelValue", "placeholder", "label-text", "is-valid"]), false && !_ctx.pumMarketing ? (_openBlock(), _createBlock(_component_base_checkbox, {
        key: 1,
        id: "request_marketing",
        modelValue: _ctx.requestData.marketing,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
          return _ctx.requestData.marketing = $event;
        }),
        "container-class": "tw-col-span-2",
        name: "marketing",
        "class": "tw-text-12",
        onClick: _cache[8] || (_cache[8] = function ($event) {
          return _ctx.userInteraction = true;
        })
      }, {
        label: _withCtx(function () {
          return [_createElementVNode("span", {
            "class": "sm:tw-block",
            innerHTML: _ctx.labels.marketing_consent
          }, null, 8 /* PROPS */, _hoisted_13), _createTextVNode(" ("), _createElementVNode("a", {
            href: "#",
            "class": "tw-underline",
            onClick: _cache[6] || (_cache[6] = _withModifiers(
            //@ts-ignore
            function () {
              return _ctx.openPrivacyDisclaimer && _ctx.openPrivacyDisclaimer.apply(_ctx, arguments);
            }, ["prevent"])),
            innerHTML: _ctx.privacy_D_section
          }, null, 8 /* PROPS */, _hoisted_14), _createTextVNode(") ")];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue"])) : _createCommentVNode("v-if", true), !_ctx.isUserLogged ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("span", {
        innerHTML: _ctx.readAndAcceptedByClicking
      }, null, 8 /* PROPS */, _hoisted_16), _createElementVNode("span", {
        innerHTML: _ctx.labels.privacy_policy_generic
      }, null, 8 /* PROPS */, _hoisted_17), _createTextVNode(" ("), _createElementVNode("a", {
        "class": "tw-underline",
        href: "#",
        onClick: _cache[9] || (_cache[9] = _withModifiers(
        //@ts-ignore
        function () {
          return _ctx.openPrivacyDisclaimer && _ctx.openPrivacyDisclaimer.apply(_ctx, arguments);
        }, ["prevent"])),
        innerHTML: _ctx.privacy_C_section
      }, null, 8 /* PROPS */, _hoisted_18), _createTextVNode(") ")])) : _createCommentVNode("v-if", true), _ctx.auctionSupervisor ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_custodian_supervisor_card, {
        "is-custodian": false,
        "is-phone-showed": false,
        "agency-item": _ctx.auctionSupervisor,
        "real-estate-id": (_b = _ctx.modelValue) === null || _b === void 0 ? void 0 : _b.id,
        "place-id": (_c = _ctx.modelValue) === null || _c === void 0 ? void 0 : _c.placeID,
        price: (_d = _ctx.modelValue) === null || _d === void 0 ? void 0 : _d.price,
        "typology-name": (_e = _ctx.modelValue) === null || _e === void 0 ? void 0 : _e.typologyName,
        labels: {
          title: _ctx.labels.auctionSupervisor,
          phone: _ctx.labels.phone
        }
      }, null, 8 /* PROPS */, ["agency-item", "real-estate-id", "place-id", "price", "typology-name", "labels"])])) : _createCommentVNode("v-if", true), !(_ctx.success && _ctx.type === 'agency') ? (_openBlock(), _createBlock(_component_base_button, {
        key: 4,
        id: "send_request_modal_button",
        "is-loading": _ctx.isSubmitting,
        "class": "tw-w-full sm:tw-w-fit tw-col-span-2 tw-justify-self-center tw-mb-20px tw-mt-10px",
        "btn-class": "tw-btn-w-primary",
        disabled: _ctx.duplicateErrorRequest || _ctx.isSubmitting || _ctx.type === 'agency' && _ctx.success,
        onClick: _cache[10] || (_cache[10] = _withModifiers(function ($event) {
          _ctx.enterPressedCb();
          _ctx.userInteraction = true;
        }, ["stop", "prevent"]))
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("span", {
            innerHTML: _ctx.success && _ctx.type === 'agency' ? _ctx.labels.success : _ctx.endedAuction ? _ctx.labels.requestInfos : _ctx.labels.sendMessage
          }, null, 8 /* PROPS */, _hoisted_20)];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["is-loading", "disabled"])) : _createCommentVNode("v-if", true)], 32 /* NEED_HYDRATION */)];
    }),
    _: 2 /* DYNAMIC */
  }, [((_b = _ctx.modelValue) === null || _b === void 0 ? void 0 : _b.subscriptionType) != _ctx.SUBSCRIPTION_TYPE.FREE && _ctx.isDesktopMode ? {
    name: "footer",
    fn: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_21, [!_ctx.advertisingPublicUserID ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        "class": "tw-h-full",
        src: _ctx.agencyData ? _ctx.agencyData.logo : '',
        alt: _ctx.labels.real_estate_agency_logo,
        style: {
          "width": "30%"
        },
        onClick: _cache[13] || (_cache[13] = _withModifiers(function ($event) {
          return _ctx.agencyData ? _ctx.agencyData.url : '#';
        }, ["stop", "prevent"]))
      }, null, 8 /* PROPS */, _hoisted_22)) : _createCommentVNode("v-if", true), _createElementVNode("div", _hoisted_23, [_ctx.isPrestigious && !_ctx.advertisingPublicUserID ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: _ctx.agencyData ? _ctx.icons.prestigeIcon : '',
        "class": "tw-absolute",
        style: {
          "top": "20px",
          "right": "20px"
        },
        height: "32",
        width: "32",
        alt: "prestige icon"
      }, null, 8 /* PROPS */, _hoisted_24)) : _createCommentVNode("v-if", true), _createElementVNode("p", _hoisted_25, [!_ctx.advertisingPublicUserID ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        "class": "agency-url tw-text-w-black tw-no-underline",
        href: _ctx.agencyData ? _ctx.agencyData.url : '#'
      }, [_createElementVNode("span", {
        "class": "tw-block tw-font-semibold tw-text-12 sm:tw-text",
        innerHTML: _ctx.agencyData ? _ctx.agencyData.name : ''
      }, null, 8 /* PROPS */, _hoisted_27), _createElementVNode("span", {
        "class": "tw-block agencyAddress tw-text-12",
        innerHTML: _ctx.agencyData ? _ctx.agencyData.address : ''
      }, null, 8 /* PROPS */, _hoisted_28)], 8 /* PROPS */, _hoisted_26)) : (_openBlock(), _createElementBlock("div", _hoisted_29, [_hoisted_30, _createElementVNode("span", {
        "class": "tw-font-semibold tw-text-12 sm:tw-text",
        innerHTML: _ctx.publicUserName ? "".concat(_ctx.publicUserName, " - Utente privato") : ''
      }, null, 8 /* PROPS */, _hoisted_31)]))]), _ctx.isPremium ? (_openBlock(), _createBlock(_component_base_button, {
        key: 1,
        id: "rm-show-phone-modal",
        "data-cy": "show-phone-btn-desktop",
        "btn-class": "tw-hidden sm:tw-block tw-mt-10px tw-btn-sm tw-btn-w-primary tw-btn-outline",
        onClick: _cache[14] || (_cache[14] = _withModifiers(function ($event) {
          _ctx.showPhone(_ctx.agencyModalData, "".concat(_ctx.pageName, " - ").concat(_ctx.location), _ctx.displayPhone);
        }, ["prevent", "stop"]))
      }, {
        "default": _withCtx(function (_ref2) {
          var hover = _ref2.hover;
          return [_createVNode(_component_phone_icon, {
            "stroke-color": hover ? '#fff' : '#2b5dff',
            width: 16,
            height: 16,
            "class": "tw-inline-block"
          }, null, 8 /* PROPS */, ["stroke-color"]), _createElementVNode("span", {
            ref: "phone-".concat(_ctx.agencyModalData.agencyId),
            "class": "tw-ml-5px",
            "data-id": "phone-".concat(_ctx.agencyModalData.agencyId),
            innerHTML: _ctx.labels.phone
          }, null, 8 /* PROPS */, _hoisted_32)];
        }),
        _: 1 /* STABLE */
      })) : _createCommentVNode("v-if", true)])])];
    }),
    key: "0"
  } : undefined]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["show-modal", "header-title", "with-custom-footer", "onClosed"])) : _ctx.errorCode === 412 ? (_openBlock(), _createBlock(_component_limit_modal, {
    key: 1,
    "show-modal": true,
    labels: {
      title: _ctx.labels.limitModalTitle,
      reached_limit: _ctx.labels.reached_limit,
      sign_in: _ctx.labels.sign_in
    },
    onClosed: _ctx.closedModal,
    onOpenSigninModal: _ctx.openSigninModal
  }, null, 8 /* PROPS */, ["labels", "onClosed", "onOpenSigninModal"])) : _ctx.errorCode === 405 || _ctx.errorCode === 409 ? (_openBlock(), _createBlock(_component_limit_saved_modal, {
    key: 2,
    "show-modal": true,
    labels: {
      title: _ctx.labels.generic_error,
      limit_saved: _ctx.errorCode === 405 ? _ctx.labels.limit_saved_not_logged : _ctx.labels.limit_saved_logged
    },
    onClosed: _ctx.closedModal
  }, null, 8 /* PROPS */, ["labels", "onClosed"])) : _ctx.errorCode === 401 ? (_openBlock(), _createBlock(_component_unauthorized_modal, {
    key: 3,
    "show-modal": true,
    labels: {
      title: _ctx.labels.unauthorizedTitle,
      unauthorized: _ctx.labels.unauthorized,
      login: _ctx.labels.login
    },
    onOpenLoginModal: _ctx.openLoginModal,
    onClosed: _ctx.closedModal
  }, null, 8 /* PROPS */, ["labels", "onOpenLoginModal", "onClosed"])) : _ctx.success && _ctx.type === 'realEstate' && _ctx.errorCode === -1 ? (_openBlock(), _createBlock(_component_contact_agency_success, {
    key: 4,
    "config-options": _ctx.successModalConfig,
    "activate-reload-cb": _ctx.loginSuccess,
    data: _ctx.successModalData,
    "is-contract-type-sale": _ctx.agencyModalData.sale && !_ctx.agencyModalData.rent && !_ctx.agencyModalData.auction,
    "wikicasa-news-url": _ctx.agencyModalData.wikicasaNewsUrl,
    "is-listing": true,
    "reopen-after-login": _ctx.reopenAfterLogin,
    labels: {
      request_sent: _ctx.labels.request_sent,
      request_sent_correctly_2: _ctx.labels.request_sent_correctly_2,
      additional_services: _ctx.labels.additional_services,
      select_options: _ctx.labels.select_options,
      similar_properties_in_email: _ctx.labels.similar_properties_in_email,
      mail_alert_mobile: _ctx.labels.mail_alert_mobile,
      send_generic_request: _ctx.labels.send_generic_request,
      send_generic_request_2: _ctx.labels.send_generic_request_2,
      mortgage_request: _ctx.labels.mortgage_request,
      mortgage_request_2: _ctx.labels.mortgage_request_2,
      phone: _ctx.labels.phone,
      news_request: _ctx.labels.news_request,
      news_request_1: _ctx.labels.news_request_1,
      news_request_2: _ctx.labels.news_request_2,
      newsletter_mobile: _ctx.labels.newsletter_mobile,
      confirm: _ctx.labels.confirm
    },
    icons: {
      facile1x: _ctx.icons.facile1x,
      facile2x: _ctx.icons.facile2x,
      crediPass: _ctx.icons.crediPass
    },
    name: _ctx.requestData.name,
    "show-modal": _ctx.success,
    "franchise-id": _ctx.agencyModalData.franchiseId,
    onShowErrorModal: _ctx.handleShowErrorModal,
    onOpenLoginModal: _ctx.openLoginModal,
    onClosedModal: _ctx.closedModal,
    onReopenAfterLogin: _ctx.switchOffReopen,
    onShowSuccessRequestSent: _cache[15] || (_cache[15] = function ($event) {
      return _ctx.showMessageSentSuccess = true;
    })
  }, null, 8 /* PROPS */, ["config-options", "activate-reload-cb", "data", "is-contract-type-sale", "wikicasa-news-url", "reopen-after-login", "labels", "icons", "name", "show-modal", "franchise-id", "onShowErrorModal", "onOpenLoginModal", "onClosedModal", "onReopenAfterLogin"])) : _createCommentVNode("v-if", true), _ctx.showMessageSentSuccess ? (_openBlock(), _createBlock(_component_generic_success_modal, {
    key: 5,
    "show-modal": _ctx.showMessageSentSuccess,
    "auto-close": 3000,
    labels: {
      actual_label: _ctx.labels.request_sent
    },
    onClosed: _ctx.closedModal
  }, null, 8 /* PROPS */, ["show-modal", "labels", "onClosed"])) : _createCommentVNode("v-if", true)]);
}